// newOrder/components/Tags/TagTextFielsEditable.js
import React, { useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import "animate.css/animate.css";
import './styles/TagTextFielsEditable.css';

const TagTextFielsEditable = (props) => {
  const [textValue, setTextValue] = useState("");
  const [error, setError] = useState(false);
  const tipText = props.prompt ? props.prompt : '';
  const isAlwaysOn = props.isAlwaysOn || false;
  const validationCase = props.validationCase || 'none';
  const isTagChecked = props.isTagChecked || false;

  useEffect(() => {
    setTextValue(props.value || "");
  }, [props.value]);

  // Validation useEffect ... (remains the same)
  useEffect(() => {
    let newError = false;
    // ... validation logic ...
     if (validationCase === 'case_4') {
      // Case 4: Tag is required (alwaysOn), Variable Value is required
      if (props.required && isAlwaysOn) {
        if (!textValue || textValue.trim() === "") {
          newError = true;
        }
      }
    } else if (validationCase === 'case_2') {
      // Case 2: Tag is not required, but if tag is selected then the Variable is required
      if (props.required && isTagChecked) {
        if (!textValue || textValue.trim() === "") {
          newError = true;
        }
      }
    }
    setError(newError);
  }, [textValue, props.required, isAlwaysOn, validationCase, isTagChecked]);


  // handleChange ... (remains the same)
  const handleChange = (event) => {
    // ... change handling logic ...
     const newValue = event.target.value;
    if (props.maxLength === undefined || newValue.length <= props.maxLength) {
      setTextValue(newValue);

      // Determine validity based on the new value and validation case
      let isValid = true;

      if (validationCase === 'case_4' && props.required) {
        // Case 4: Always required if alwaysOn tag
        if (!newValue || newValue.trim() === "") {
          isValid = false;
        }
      } else if (validationCase === 'case_2' && props.required && isTagChecked) {
        // Case 2: Required only if tag is checked
        if (!newValue || newValue.trim() === "") {
          isValid = false;
        }
      }

      props.onChange({
        name: props.param,
        value: newValue,
        isValid: isValid
      });
    }
  };


  // getHelperText ... (remains the same)
   const getHelperText = () => {
   // ... helper text logic ...
     if (error) {
      if (validationCase === 'case_4') {
        return "This field is required";
      } else if (validationCase === 'case_2') {
        return "This field is required if active";
      }
    }
    return "";
  };


  return (
    <Grid container className="tag-textfield-editable-container">
      <Grid item xs={12} sm={12} className="tag-textfield-editable-item">
        <Tooltip title={tipText} placement="top" arrow>
          <TextField
            className="tag-textfield-editable-input"
            label={props.label}
            size="small" // Ensure size="small" is used
            variant={props.variant || "outlined"} // Use passed variant or default
            value={textValue}
            placeholder={props.prompt}
            onChange={handleChange}
            error={error}
            helperText={getHelperText()}
            inputProps={{
              tabIndex: props.tabIndex || 0
              // No explicit style needed here if CSS is removed
            }}
            InputProps={{
              // style: { height: '40px' }, // REMOVED explicit height
              classes: {
                 root: "tag-textfield-editable-input-root" // CSS class might define height
              },
              endAdornment: null
            }}
            autoFocus={false}
            // tabIndex={props.tabIndex || 0} // Only needed once
          />
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default TagTextFielsEditable;